import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const emailmasterAdapter = createEntityAdapter({})

const initialState = emailmasterAdapter.getInitialState()

export const emailmasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getemailmaster: builder.query({
            query: () => ({
                url: '/emailmaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedemailmaster = responseData.map(emailmaster => {
                    // console.log(emailmaster)
                    emailmaster.id = emailmaster._id
                    // console.log(emailmaster)
                    return emailmaster
                });
                return emailmasterAdapter.setAll(initialState, loadedemailmaster)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'EMAILMASTER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'EMAILMASTER', id }))
                    ]
                } else return [{ type: 'EMAILMASTER', id: 'LIST' }]
            }
        }),
        addNewemailmaster: builder.mutation({
            query: initialUserData => ({
                url: '/emailmaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'EMAILMASTER', id: "LIST" }
            ]
        }),
        addBulkemailmaster: builder.mutation({
            query: initialUserData => ({
                url: '/emailmaster/addbulk',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'EMAILMASTER', id: "LIST" }
            ]
        }),
        updateemailmaster: builder.mutation({
            query: initialUserData => ({
                url: '/emailmaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'EMAILMASTER', id: arg.id }
            ]
        }),        
        deleteemailmaster: builder.mutation({
            query: ({ id }) => ({
                url: `/emailmaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'EMAILMASTER', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetemailmasterQuery,
    useAddNewemailmasterMutation,
    useAddBulkemailmasterMutation,
    useUpdateemailmasterMutation,
    useDeleteemailmasterMutation, 
} = emailmasterApiSlice

// returns the query result object
export const selectemailmasterResult = emailmasterApiSlice.endpoints.getemailmaster.select()

// creates memoized selector
const selectemailmasterData = createSelector(
    selectemailmasterResult,
    emailmasterResult => emailmasterResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllemailmaster,
    selectById: selectemailmasterById,
    selectIds: selectemailmasterIds
    // Pass in a selector that returns the users slice of state
} = emailmasterAdapter.getSelectors(state => selectemailmasterData(state) ?? initialState)